export default __webpack_public_path__ + "static/media/cloud-1.fd6fcbfd.webp";